import { StoredPromotion } from 'modules/promotion/duck/model';
import AtlStorage from 'api/AtlStorage';

const storage = new AtlStorage('marketplace.promotion', window.sessionStorage);

export default (state: StoredPromotion | null = storage.load()) => state;
